import moment from 'moment';

import TU from 'constants/time/units.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromMomentToIso, fromMomentToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

const L = logger('parseBusinessHour');

const RE_FORMAT = /^\d\d:\d\d:\d\d$/;

const get = (what, m) => {
  const result = m.get(what);
  if (Number.isSafeInteger(result)) return result;

  return NaN;
};

const parseBusinessHour = (value) => {
  const raw = value;

  const empty = raw === '' || raw === null || raw === void 1;
  const formated = fromAnyToBool(fromAnyToTrimmed(raw).match(RE_FORMAT));

  try {
    if (!formated) {
      return {
        hours: NaN,
        minutes: NaN,
        seconds: NaN,
        iso: '',
        zulu: '',
        raw,
        is: { valid: false, empty, formated },
      };
    }

    const m = moment(raw, 'HH:mm:ss');
    const valid = m.isValid();
    const iso = fromMomentToIso(m);
    const zulu = fromMomentToZulu(m);

    const hours = get(TU.md.h, m);
    const minutes = get(TU.md.m, m);
    const seconds = get(TU.md.s, m);

    return { iso, zulu, raw, hours, minutes, seconds, is: { valid, empty, formated } };
  } catch (e) {
    L.warn('()', e);
    return {
      hours: NaN,
      minutes: NaN,
      seconds: NaN,
      iso: '',
      zulu: '',
      raw,
      is: { valid: false, empty, formated },
    };
  }
};

export default parseBusinessHour;
